import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CreateForm from '../../components/CreateForm/CreateForm';
import Title from '../../components/Title';

export default function CreateClientPage() {
    const dispatch = useDispatch();

    useEffect(() => {}, [dispatch]);

    return (
        <div>
            <Title subText="Please fill information about client below">
                Add new client
            </Title>
            <CreateForm />
        </div>
    );
}
